import React from "react";

const Invoice = () => {
  return (
    <div className="invoice-container">
      <div className="invoice-content">
        <div className="header">
          <img src="/images/logo-queen-center.svg" alt="Logo Queen center" />
          <div className="right">
            <p className="name">Queen Center</p>
            <p className="address">
              Graafseweg 274
              <br />
              6532 ZV Nijmegen
            </p>
            <p className="phone">+31 (0) 6 15 85 21 50</p>
            <p>info@queencenter.nl</p>
            <p>www.queencenter.nl</p>
            <p className="kvk">Kvk: 68904134</p>
            <p>BTW: NL242569651B01</p>
          </div>
        </div>
        <div className="invoice-info">
          <div className="left">
            <h1 className="title">Factuur</h1>
            <p className="client-name">Arienne Wassink</p>
            <p className="client-email">arienne.wassink@gmail.com</p>
          </div>
          <div className="right">
            <div className="invoice-number">
              <p className="title">Factuurnummer</p>
              <p className="number">2025.1.0001</p>
            </div>
            <div className="invoice-date">
              <p className="title">Datum</p>
              <p className="date">25 februari 2025</p>
            </div>
            <div className="invoice-reservation">
              <p className="title">Reserveringsnummer</p>
              <p className="number">#QC13903</p>
            </div>
            <div className="invoice-payment">
              <p className="title">Betaalmethode</p>
              <p className="gateway">iDeal</p>
            </div>
          </div>
        </div>
        <div className="invoice-details">
          <div className="invoice-details-header">
            <p className="title">Omschrijving</p>
            <p className="title">Prijs</p>
          </div>
          <div className="invoice-details-content">
            <p className="description>">1x Queen Center Reservering</p>
            <p className="price">€ 20.66 (excl. btw)</p>
          </div>
          <div className="invoice-details-order">
            <p className="date">
              <p className="title">Datum:</p>
              <p>18 februari 2015</p>
            </p>
            <p className="time">
              <p className="title">Tijd:</p>
              <p>11:00 uur</p>
            </p>
            <p className="treatment">
              <p className="title">Behandeling:</p>
              <p>Lipcorrectie (vullen)</p>
            </p>
          </div>
          <hr />
          <div className="invoice-details-footer">
            <div className="total">
              <div className="subtotal">
                <p className="title">Subtotaal</p>
                <p className="price">€ 20.66 (excl. btw)</p>
              </div>
              <div className="tax">
                <p className="title">BTW (21%)</p>
                <p className="price">€ 4.34</p>
              </div>
              <div className="total-price">
                <p className="title">Totaal</p>
                <p className="price">€ 25.00</p>
              </div>
            </div>
          </div>
        </div>
        <div className="invoice-footer">
          <p className="footer-text">
            Bedankt voor uw reservering bij Queen Center. Wij hopen dat u een
            fijne behandeling heeft gehad. Mocht u vragen hebben over uw
            factuur, neem dan contact met ons op.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
